import { useState, useEffect, useContext } from 'react'; // 🚀 Added hooks
import { ContextEngine } from "../ContextEngine";       // 🚀 Added your Engine
import { DJANGO_API } from "../../../api";  

export const useTableData = () => { 
  const { context, updateContext } = useContext(ContextEngine);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const { activeNamespace, activeSheet, activeFolder, activeSection, activeProject } = context.view || {};

  useEffect(() => {
    // 1. Guard & Reset Logic
    const isPathComplete = activeProject && activeSection && activeFolder && activeNamespace && activeSheet;
    
    if (!isPathComplete) {
      // Clear data immediately so the UI doesn't look "stuck" on old results
      updateContext("currentTableData", []); 
      return;
    }

    // 2. Setup AbortController
    const controller = new AbortController();
    const { signal } = controller;

    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const query = new URLSearchParams({
          project: activeProject,
          section: activeSection,
          folderId: activeFolder,
          namespace: activeNamespace,
          sheet: activeSheet
        }).toString();

        const response = await fetch(`${DJANGO_API}/api/tenant-data?${query}`, { signal });
        
        // Handle non-200 responses (Django errors)
        if (!response.ok) throw new Error(`Server Error: ${response.status}`);
        
        const result = await response.json();

        // 3. Only update if the user hasn't already moved to a new sheet
        if (!signal.aborted) {
          updateContext("currentTableData", result.data || []);
        }

      } catch (err) {
        if (err.name === 'AbortError') {
          console.log("Fetch aborted for:", activeSheet);
        } else {
          setError(err.message);
          console.error("Fetch Error:", err);
        }
      } finally {
        // 4. Critical: Only stop loading if this was the latest request
        if (!signal.aborted) setLoading(false);
      }
    };

    fetchData();

    // 5. Cleanup: Abort the fetch if any dependency changes
    return () => controller.abort();

  }, [activeProject, activeSection, activeNamespace, activeFolder, activeSheet, updateContext]); 

  return { loading, error };
};
